import axios from 'axios';

export default {
	/**
	 * Gets recomended product for a selected product
	 * @returns list of sugested products based on provided product id
	 */
	async GetProductSuggestions(query) {
		return await axios.post( window.CONFIG.productRecommendationApi+'Recommendation/GetProductSuggestions', query, {withCredentials: false});
	},
	/**
	 * Gets recomended product for a selected product
	 * @returns list of co purchased products based on provided product id
	 */
	async GetCoPurchases(query) {
		return await axios.post( window.CONFIG.productRecommendationApi+'Recommendation/GetCoPurchase', query, {withCredentials: false});
	},

	async GetLowestProductPrice(data) {
		return await axios.post( process.env.VUE_APP_FIXIT_NO_BOOKING_URL +'/api/Product/get-products-lowest-price', data, {withCredentials: false});
	},

	async GetLowestBundlePrice(campaignId) {
		return await axios.get( process.env.VUE_APP_FIXIT_NO_BOOKING_URL +'/api/Product/get-bundle-lowest-price?campaignId='+campaignId, {withCredentials: false});
	},
};
